export const SET_DATA = "SET_DATA";

const initialState = {
  isitadd: false,
  architecture: "",
  offer: "",
  use_case: "",
  use_case_type: "",
  _popUpUseCase: false,
  _disableBtn: false,
  allUseCase: [],
  isLoading: true,
  refreshUseCase: false,
  sPage: 1,
  use_case_per_page: 10,
  total_use_case: 0,
  _refetch: false,
  useCaseId: null,
  confirmdisable: false,
  useCaseDetails: {},
  use_case_abbreviation: "",

  // sku managemnt redux value
  isSkuLoading: true,
  sheetName: "",
  save_sheet_name_disable: false,
  _refetch_sheet: false,
  onboard_eligibility: false,
};

export default (state = initialState, action = {}) =>
  action.type === SET_DATA ? { ...state, ...action.payload } : state;
